(() => {
  const selector = '[data-steinara-carousel]';

  function initCarousel(root) {
    if (!root || root.dataset.steinaraCarouselReady === 'true') return;

    const track = root.querySelector('.steinara-collection-intro__grid--carousel');
    const previous = root.querySelector('[data-steinara-carousel-prev]');
    const next = root.querySelector('[data-steinara-carousel-next]');
    if (!track || !previous || !next) return;

    const cards = Array.from(track.querySelectorAll('.steinara-collection-intro__item'));
    if (cards.length < 4) return;

    root.dataset.steinaraCarouselReady = 'true';

    const getMaxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const getCardLeft = (card) =>
      card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    const updateControls = () => {
      const maxScroll = getMaxScroll();
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    const scrollToCard = (index) => {
      const maxScroll = getMaxScroll();
      const left = Math.min(getCardLeft(cards[index]), maxScroll);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    const move = (direction) => {
      const scrollPosition = track.scrollLeft;
      let currentIndex = 0;
      cards.forEach((card, index) => {
        const cardPosition = getCardLeft(card);
        if (cardPosition <= scrollPosition + 3) currentIndex = index;
      });
      scrollToCard(Math.max(0, Math.min(cards.length - 1, currentIndex + direction)));
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  function initWithin(scope = document) {
    if (scope.matches?.(selector)) initCarousel(scope);
    scope.querySelectorAll?.(selector).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin());
  } else {
    initWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();
